module.exports = __webpack_public_path__ + "static/media/Carrot.4cc99e10.png";